(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-card-list.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/charity-card-list.js');

'use strict';

const {
  SelectCharityCard,
  SelectNoCharityCard,
  MoreCharitiesText
} = svs.lyckoplatsen.components.shared_charity.react.components;
const {
  SelectCharityHeader
} = svs.lyckoplatsen.components.page_related.react.components;
const {
  activeCharitiesAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useAtomValue
} = jotai;
const CharityCardList = _ref => {
  let {
    wagerId
  } = _ref;
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!wagerId) {
    return null;
  }
  if (!(activeCharities !== null && activeCharities !== void 0 && activeCharities.length)) {
    return React.createElement("div", {
      className: "lp-page-related-charity-container"
    }, React.createElement(SelectCharityHeader, null));
  }
  return React.createElement("div", {
    className: "lp-page-related-charity-container"
  }, React.createElement(SelectCharityHeader, null), React.createElement("div", {
    className: "lp-charity-cards-container"
  }, activeCharities.map(c => React.createElement(SelectCharityCard, {
    charity: c,
    wagerId: wagerId,
    key: c.charityId,
    showButtonInFooter: true
  })), React.createElement(SelectNoCharityCard, null)), React.createElement(MoreCharitiesText, null));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  CharityCardList
});

 })(window);